var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemImageAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.938 4c.614 0 1.111.447 1.111 1s-.497 1-1.111 1H5.333c-.613 0-1.11.448-1.11 1v7.298L8.933 9.35c.202-.212.493-.338.802-.349.3-.02.61.095.827.292l4.77 4.293 1.437-1.293a1.2 1.2 0 0 1 1.571 0l1.437 1.293V11c0-.553.496-1 1.11-1S22 10.447 22 11v6c0 1.654-1.496 3-3.333 3H5.333c-1.797 0-3.259-1.29-3.32-2.896q-.005-.024-.006-.05C2.006 17.035 2 17.019 2 17V7c0-1.654 1.496-3 3.333-3Zm-3.097 7.471L4.29 17.299c.142.403.548.701 1.043.701h13.334c.613 0 1.11-.448 1.11-1v-.586l-2.221-2-1.437 1.293a1.2 1.2 0 0 1-1.571 0zM19 2a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V6h-1a1 1 0 1 1 0-2h1V3a1 1 0 0 1 1-1"
})));
export default SvgGemImageAdd;